import classNames from "classnames";
import AqiProgress from "./AqiProgress.tsx";
import { homeAtom } from "@/atoms/home";
import BaseContent from "@/components/HomeMain/Default/VendorLayout/BaseContent";
const ChartData: React.FC<any> = ({ aqi = undefined }: any) => {
  const homeData = useAtomValue(homeAtom);
  aqi = (aqi || homeData?.data?.["aqi"]) ?? {};
  return (
    <>
      <BaseContent
        className={classNames([
          "w-full flex flex-col justify-start items-stretch gap-y-16 rounded-10  backdrop-blur-10 p-16",
          "bg-[var(--app-bg-08)]",
        ])}
      >
        <AqiProgress aqi={aqi} />
      </BaseContent>
    </>
  );
};
export default ChartData;
